<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da želite da obrišete podsetnik: {{ reminder.title }}?
      </p>
    </div>
    <hr />
    <div class="footer">
      <button
        type="submit"
        class="btn btn-default btn--mod close-btn"
        @click="closeModal"
      >
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        @click="deleteReminder"
        :disabled="loading"
      >
        <p v-if="!loading">Obriši</p>
        <spinner :size="20" line-fg-color="#610d0d" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
import { DateTime } from 'luxon';

export default {
  computed: {
    ...mapState('table', ['modalVisible', 'reminder'])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['getCommunityReminders']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', []),
    async deleteReminder() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      try {
        await axios.delete(`/reminder/${this.reminder.id}`);
        if (this.$router.history.current.name == 'communityReminders') {
          const currentDate = DateTime.local();
          await this.getCommunityReminders({
            communityId: this.$store.getters.getActiveCommunity.id,
            filters: {
              dateTo: currentDate
                .set({ year: currentDate.year + 1 })
                .toFormat('yyyy-MM-dd')
            }
          });
        } else {
          this.$router.push({
            name: 'communityReminders',
            params: {
              id: this.$store.getters.getActiveCommunity.id
            }
          });
        }
        this.loading = false;
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        console.log(error);
        this.showFailModal();
      }
    }
  }
};
</script>

<style scoped>
.close-btn {
  margin-right: 4px;
}

.btn--mod {
  height: 35px;
  min-width: 75px;
  margin-left: 5px;
  align-self: center;
}
</style>
